/**
 * Performance Fixes for MebleFurniture.com
 * Version 2.1 - Window dimension caching + matchHeight optimization
 * 
 * Load this AFTER scripts.js
 */

(function($) {
  'use strict';

  // Cache window dimensions
  var windowCache = {
    width: window.innerWidth,
    height: window.innerHeight,
    update: function() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
    }
  };

  // Patch $(window).width() and $(window).height() to use cache
  var originalWidth = $.fn.width;
  var originalHeight = $.fn.height;
  
  $.fn.width = function() {
    if (this[0] === window) return windowCache.width;
    return originalWidth.apply(this, arguments);
  };
  
  $.fn.height = function() {
    if (this[0] === window) return windowCache.height;
    return originalHeight.apply(this, arguments);
  };

  // Increase matchHeight throttle
  if (typeof $.fn.matchHeight !== 'undefined') {
    $.fn.matchHeight._throttle = 300;
  }

  // Debounced resize handler to update cache
  var resizeTimeout;
  $(window).on('resize.perfFix orientationchange.perfFix', function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
      windowCache.update();
      if (typeof $.fn.matchHeight !== 'undefined') {
        $.fn.matchHeight._update(false);
      }
    }, 150);
  });

  // Debug API
  window.MeblePerformance = {
    version: '2.1',
    windowCache: windowCache,
    forceUpdate: function() {
      windowCache.update();
      if (typeof $.fn.matchHeight !== 'undefined') {
        $.fn.matchHeight._update(false);
      }
    }
  };

})(jQuery);
